<template>
    <section class="page-dashbord-subCategory mt-5">
        <div class="container">
            <div class="wrapper-form px-5 shadow py-4 mb-5">
                <div class="row">
                    <div class="col-12 col-md-4">
                        <div class="group-form">
                            <label v-if="!forms.category">انتخاب دسته بندی</label>
                            <select v-validate="'required'" name="category" v-model="forms.category" @change="selectCat">
                                <option value="'انتخاب دسته بندی'" selected disabled>انتخاب دسته بندی</option>
                                <option v-for="(option,index) in categories" :value="option.id" :key="index">
                                    {{option.category}}
                                </option>
                            </select>
                            <span v-if="errors.has('category')" class="is-danger">فیلد نباید خالی باشد</span>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="group-form">
                            <input type="text" v-validate="'required'" name="subCategory" :class="{active:forms.subcategory != '' }" v-model="forms.subcategory">
                            <span class="bar"></span>
                            <label class='statr'>نام زیر دسته به فارسی</label>
                            <span v-if="errors.has('subCategory')" class="is-danger">فیلد نباید خالی باشد</span>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="group-form">
                            <input type="text" v-validate="'required'" name="en_subCategory" :class="{active:forms.en_subcategory != '' }" v-model="forms.en_subcategory">
                            <span class="bar"></span>
                            <label class='statr'>نام زیر دسته به انگیلیسی</label>
                            <span v-if="errors.has('en_subCategory')" class="is-danger">فیلد نباید خالی باشد</span>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="text-left form-action mt-2">
                            <button class="font-16 px-5 py-2 bttn-fill bttn bttn-success" v-ripple @click="addSubCat">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="shadow shadow-sm  mb-5 bg-white">
                        <b-table stacked="lg" :fields="fieldsItems" :items="allSubCategories" class="text-center">
                            <template v-slot:cell(category)="data" >
                                <p class="m-0">
                                    {{data.item.category , categories| findParent}}
                                </p>
                            </template>
                            <template v-slot:cell(subcategory)="data" >
                                <p class="m-0" v-if="!data.item.isEdit">
                                    {{data.item.subcategory}}
                                </p>
                                <div class="group-form mb-0" v-if="data.item.isEdit">
                                    <input type="text" :class="{active:data.item.subcategory != ''}" v-model="data.item.subcategory">
                                    <span class="bar"></span>
                                </div>
                            </template>
                            <template v-slot:cell(en_subcategory)="data" >
                                <p class="m-0" v-if="!data.item.isEdit">
                                    {{data.item.en_subcategory}}
                                </p>
                                <div class="group-form mb-0" v-if="data.item.isEdit">
                                    <input type="text" :class="{active:data.item.en_subcategory != ''}" v-model="data.item.en_subcategory">
                                    <span class="bar"></span>
                                </div>
                            </template>
                            <template v-slot:cell(action)="data" >
                                <div class="d-flex justify-content-between">
                                    <span data-balloon-pos="up" data-balloon="حذف" v-if="!data.item.isEdit">
                                        <button
                                          class="bttn-material-circle bttn-jelly bttn-md bttn-danger text-center"
                                          v-ripple
                                          @click.stop="remove(data.item, data.index)"
                                        >
                                          <i class="flaticon-dustbin"></i>
                                        </button>
                                      </span>
                                      <span data-balloon-pos="up" data-balloon="ویرایش" v-if="!data.item.isEdit">
                                        <button
                                          class="bttn-material-circle bttn-jelly bttn-md bttn-primary text-center"
                                          v-ripple
                                          @click.stop="edit(data.item, data.index)"
                                        >
                                          <i class="flaticon-content"></i>
                                        </button>
                                      </span>
                                      <span data-balloon-pos="up" data-balloon="دخیره" v-if="data.item.isEdit">
                                        <button
                                          class="bttn-material-circle bttn-jelly bttn-md bttn-success text-center"
                                          v-ripple
                                          @click.stop="update(data.item, data.index)"
                                        >
                                          <i class="flaticon-cogwheel"></i>
                                        </button>
                                      </span>
                                      <span data-balloon-pos="up" data-balloon="انضراف" v-if="data.item.isEdit">
                                        <button
                                          class="d-flex justify-content-between align-items-center bttn-material-circle bttn-jelly bttn-md bttn-danger text-center"
                                          v-ripple
                                          @click.stop="cancel(data.item, data.index)"
                                        >
                                          <i class="flaticon-remove"></i>
                                        </button>
                                      </span>
                                </div>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import contactForm from 'cp/contact-form.vue'

export default {
    name: 'page-dashbord-subCategory',
    components: {
        contactForm
    },
    data () {
        return {
            forms: {
                category: null,
                en_subcategory: '',
                subcategory: ''
            },
            fieldsItems: [
                { key: 'category', label: 'دسته' },
                { key: 'subcategory', label: 'نام زیر دسته به فارسی' },
                { key: 'en_subcategory', label: 'نام زیر دسته به انگلیسی' },
                { key: 'action', label: 'عملیات' }
            ]
        }
    },
    computed: {
        categories () {
            return this.$store.state.dashboardCategory.listCategory
        },
        allSubCategories () {
            return this.$store.state.dashboardCategory.allSubCategories
        }
    },
    filters: {
        findParent: function (catId, allCats) {
            if (!allCats || !catId) return 'نام دسته'
            let nameParentCat = allCats.find(e => e.id == catId)
            return nameParentCat && nameParentCat.category ? nameParentCat.category : ''
        }
    },
    mounted () {
        this.$store.dispatch('dashboardCategory/getAllCategory')
        this.$store.dispatch('dashboardCategory/getAllSubCategories')
    },
    methods: {
        remove (item, index) {
            this.$store.dispatch('dashboardCategory/deleteSubCat', { id: item.id, index })
        },
        edit (item, index) {
            this.$set(this.allSubCategories[index], 'isEdit', !this.allSubCategories[index].isEdit)
        },
        update (item, index) {
            this.$set(this.allSubCategories[index], 'isEdit', !this.allSubCategories[index].isEdit)
            let FilterItem = Object.assign({}, item)
            delete FilterItem.category
            delete FilterItem.isEdit
            this.$store.dispatch('dashboardCategory/updateSubCat', FilterItem)
        },
        cancel (item, index) {
            this.$set(this.allSubCategories[index], 'isEdit', false)
        },
        selectCat () {

        },
        async addSubCat () {
            let result = this.$validator.validate()
            if (!result) {
                this.$root.showWarnMsg({
                    message: 'لطفا فرم را تکمیل کنید ... '
                })
                return
            }
            await this.$store.dispatch('dashboardCategory/addSubCat', this.forms)
            this.$store.dispatch('dashboardCategory/getAllSubCategories')
            this.forms = {
                category: null,
                en_subcategory: '',
                subcategory: ''
            }
            this.$validator.reset()
        }
    }
}
</script>
<style lang="less">
@import (reference) "../../assets/css/variable.less";
.page-dashbord-subCategory {
  .box-clear;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/subcategory.vue